import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { User } from "@beeldit/user-and-access/users/models/User";
import React, { useContext } from "react";
import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";
import { ArrowClockwise } from "@phosphor-icons/react";

interface MenuItem {
  label: string;
  to: string;
  children?: MenuItem[];
  icon?: any;
  roles?: string[];
}

function createMenuItem(
  item: MenuItem,
  user: User,
  handleNavigation: (to: string) => void,
  key?: string
) {
  if (item.children) {
    if (item.roles && !item.roles.includes(user.role)) return null;
    return (
      <div key={key}>
        <NavDropdown title={item.label} key={key} id={""}>
          {item.children.map((child: MenuItem, key2: any) => {
            let auxKey = key + "-" + key2;
            return createMenuItem(child, user, handleNavigation, auxKey);
          })}
        </NavDropdown>
      </div>
    );
  }

  if (item.roles && !item.roles.includes(user.role)) return null;
  return (
    <Nav.Item key={key}>
      <span
        onClick={() => handleNavigation(item.to)}
        className="nav-link hover-translate text-black"
        style={{ cursor: "pointer" }}
      >
        {item.icon} {item.label}
      </span>
    </Nav.Item>
  );
}

function AppNavbar(props: any) {
  const { user } = useContext(AuthContext);
  const { changed, showModal } = useContext(ChangeDectionContext);

  const { items } = props;
  const navigate = useNavigate();

  const handleNavigation = (to: string) => {
    if (changed) {
      showModal(
        () => navigate(to), // Confirmación
        () => console.log("Navegación cancelada") // Cancelación opcional
      );
    } else {
      navigate(to);
    }
  };

  const handleLogout = () => {
    if (changed) {
      showModal(
        () => navigate("/login"), // Confirmación
        () => console.log("Logout cancelado") // Cancelación opcional
      );
    } else {
      navigate("/login");
    }
  };

  return (
    <Navbar collapseOnSelect expand="lg" fixed="top">
      <Navbar.Brand href="#home">
        <img src="/mn.png" alt="Mascotas Nazarenas" width="150" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto">
          {items.map((item: MenuItem, key: any) => {
            if (!user) return null;
            return createMenuItem(item, user, handleNavigation, key);
          })}
        </Nav>
        <Nav>
          <Button
            variant="link"
            onClick={() => window.location.reload()}
            className="text-decoration-none me-2"
            title="Refrescar aplicación"
          >
            <ArrowClockwise size={20} />
          </Button>
          <NavDropdown
            title={`Hola ${user?.name ?? ""}!`}
            id="collasible-nav-dropdown"
          >
            <NavDropdown.Item href="#profile">Perfil</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#logout" onClick={handleLogout}>
              Cerrar sesión
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default AppNavbar;
